<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="dialog"
      lazy
      max-width="600px"
      transition="scale-transition"
    >
      <v-btn
        slot="activator"
        fab
        small
        color="teal"
      >
        <v-tooltip
          left
          transition="scroll-x-reverse-transition"
        >
          <template
            v-slot:activator="{ on }"
          >
            <v-icon
              large
              v-on="on"
            >
              keyboard_arrow_down
            </v-icon>
          </template>
          <span>Mehr Details anzeigen</span>
        </v-tooltip>
      </v-btn>


      <v-card>
        <v-tabs
          v-model="activeTab"
          color="teal"
          fixed-tabs
          slider-color="yellow"
        >
          <v-tab class="pa-3">
            Zur Person
          </v-tab>
          <v-tab class="pa-3">
            Biografie
          </v-tab>
          <v-spacer />
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-tabs>
        <v-tabs-items v-model="activeTab">
          <v-tab-item>
            <v-card-text>
              <ul class="person__items">
                <li
                  v-if="items.knownFor"
                  class="person__item"
                >
                  <span>Bekannt als: </span>
                  {{ items.knownFor }}
                </li>
                <li
                  v-if="items.birthday"
                  class="person__item"
                >
                  <span>Geboren am: </span>
                  {{ items.birthday }}
                </li>
                <li
                  v-if="items.placeOfBirth"
                  class="person__item"
                >
                  <span>Geburtsort: </span>
                  {{ items.placeOfBirth }}
                </li>

                <li
                  v-if="items.deathday"
                  class="person__item"
                >
                  <span>Gestorben am: </span>
                  {{ items.deathday }}
                </li>
                <li
                  v-if="items.movieCredits> 0"
                  class="person__item"
                >
                  <span>Film-Rollen: </span>

                  {{ items.movieCredits }}
                </li>
                <li
                  v-if="items.tvCredits"
                  class="person__item"
                >
                  <span>TV-Rollen: </span>

                  {{ items.tvCredits }}
                </li>
                <li
                  v-if="items.crewCredits"
                  class="person__item"
                >
                  <span>Mitgewirkt/Produziert: </span>

                  {{ items.crewCredits }}
                </li>
                <li
                  v-if="items.homepage"
                  class="person__item"
                >
                  <span>Offizielle Webseite: </span>
                  <a
                    :href="items.homepage"
                    class="person__links"
                    target="_blank"
                    rel="noopener noreferrer"
                  >&nbsp;{{ items.homepage }}</a>
                </li>
              </ul>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="teal"
                flat
                small
                @click="dialog = false"
              >
                Schließen
              </v-btn>
            </v-card-actions>
          </v-tab-item>
          <v-tab-item>
            <v-card-text>
              <p class="person__biography-text">
                {{ items.biography }}
              </p>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="teal"
                small
                flat
                @click="dialog = false"
              >
                Schließen
              </v-btn>
            </v-card-actions>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'DetailsModal',
  props: {
    items: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      activeTab: null,
    };
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    modalState() {
      return this.$store.getters.detailsModal;
    },
  },
  created() {
    // console.log('items:', this.items);
  },
  methods: {
    closeModal() {
      this.$store.commit('closeDetailsModal');
    },
  },
};
</script>

<style lang="scss" scoped>
.person {
  &__items {
    padding: 0 10px;
    font-size: 14px;
    font-weight: 300;
    text-align: justify;
    list-style: none;

    @media (max-width: 960px) {
      font-size: 14px;
    }

    @media (max-width: 768px) {
      font-size: 14px;
    }

    @media (max-width: 600px) {
      font-size: 13px;
    }

    span {
      font-weight: 400;
    }
  }

  &__item {
    font-weight: 300;
    margin-bottom: 10px;

    @media (max-width: 960px) {


    }

    @media (max-width: 600px) {


    }
  }

  &__links {
    color: white;
    text-decoration: none;
  }

  &__biography-text {
    padding: 0px 10px;
    font-size: 14px;
    font-weight: 300;
    text-align: justify;

    @media (max-width: 600px) {
      font-size: 13px;
    }
  }
}
</style>
